/**
 * 디바이스(IoT 노드) 타입 정의
 */
// ---------------------------------------------------------------------------
// Enums
// ---------------------------------------------------------------------------
export const DeviceStatus = {
    /** 정상 운영 중 */
    ACTIVE: 'ACTIVE',
    /** 경고 상태 (임계값 초과 센서 존재) */
    WARNING: 'WARNING',
    /** 오류 발생 (센서 장애 또는 통신 이상) */
    ERROR: 'ERROR',
    /** 오프라인 (마지막 응답 초과) */
    OFFLINE: 'OFFLINE',
};
export const DeviceType = {
    /** 센서 전용 노드 */
    SENSOR_NODE: 'sensor_node',
    /** 게이트웨이 (여러 노드 중계) */
    GATEWAY: 'gateway',
    /** 액추에이터 (밸브, 펌프 등 제어 가능) */
    ACTUATOR: 'actuator',
};
// ---------------------------------------------------------------------------
// 제어 명령 (MQTT 페이로드)
// ---------------------------------------------------------------------------
export const CommandType = {
    REBOOT: 'REBOOT',
    OTA_UPDATE: 'OTA_UPDATE',
    SET_INTERVAL: 'SET_INTERVAL',
    ACTUATE: 'ACTUATE',
    REPORT: 'REPORT',
    /** 센서cam 즉시 촬영 → 생육 사진 업로드. 같은 장비 번호의 센서main 은 무시한다 */
    CAPTURE: 'CAPTURE',
};
//# sourceMappingURL=device.js.map